import React from 'react'
import { Container, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

export const FaqCareer = () => {
  return (
        <section className='faq-section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>FAQ</h5>
                    <h4>Have questions? We’ve got answers. Whether you’re curious about our hiring process, work culture, or current openings, we’re here to guide you every step. </h4>
                </div>
                <Row className='align-items-center'>
                    <div className='col-lg-6' data-aos="fade-up-right"  data-aos-duration="2000">
                        <div className='position-relative faq-margin'>
                            <div className='faq-img text-center'>
                                <img src="../assets/images/faq-img.png" alt="" />
                            </div>

                            <div className='faq-shap-1'>
                                <img src="../assets/images/faq-shap-1.svg" alt="" />
                            </div>
                            <div className='faq-shap-2'>
                                <img src="../assets/images/faq-shap-2.svg" alt="" />
                            </div>
                            <div className='faq-shap-3'>
                                <img src="../assets/images/faq-shap-3.svg" alt="" />
                            </div>
                            <div className='faq-shap-4'>
                                <img src="../assets/images/faq-shap-4.svg" alt="" />
                            </div>
                            <div className='faq-shap-5'>
                                <img src="../assets/images/faq-shap-5.svg" alt="" />
                            </div>
                            <div className='faq-shap-6'>
                                <img src="../assets/images/faq-shap-6.svg" alt="" />
                            </div>
                            <div className='faq-shap-7'>
                                <img src="../assets/images/faq-shap-7.svg" alt="" />
                            </div>
                            <div className='faq-shap-8'>
                                <img src="../assets/images/faq-shap-8.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='faq-accordion'>
                            <Accordion defaultActiveKey="0" flush>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>What kind of roles does IMUII offer?  </Accordion.Header>
                                    <Accordion.Body>We offer diverse roles across tech, design, and strategy—including frontend and backend development, mobile app development, UI/UX design, project management, QA testing, and cloud engineering. Whether you're an entry-level developer or a senior tech lead, there's a place at IMUII for passionate minds to grow and innovate in cutting-edge environments. </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Is remote work or hybrid mode available? </Accordion.Header>
                                    <Accordion.Body>  Yes, IMUII supports both hybrid and remote work options, depending on the role and project needs. We value flexibility and productivity equally, empowering our team to choose the environment where they perform best. Collaboration tools and regular check-ins keep us all connected, whether working from the office or remotely.  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>What is the work culture like at IMUII?</Accordion.Header>
                                    <Accordion.Body>At IMUII, we foster a collaborative, open, and innovation-driven culture. Our environment encourages experimentation, creativity, and continuous learning. From team hackathons to daily stand-ups, we ensure every voice is heard and every idea counts. We value ownership, honesty, and team spirit above all. </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Do you offer internship or trainee programs? </Accordion.Header>
                                    <Accordion.Body> Yes, we offer structured internship and training programs for students and fresh graduates. These programs provide hands-on experience across real-world projects under expert mentorship. Interns gain valuable exposure to industry tools, agile processes, and modern tech stacks—preparing them for full-time roles at IMUII and beyond </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>
  )
}
